import React from 'react';
import { Row, Col } from 'antd';
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { FiSearch } from 'react-icons/fi';

export default function SearchAndFilter({ data }) {
  // const filtered_domain = sessionStorage.getItem('filtered_workflow_domain') || '';
  // const filtered_workflow_client = sessionStorage.getItem('filtered_workflow_client') || '';
  // const filtered_workflow_engagement = sessionStorage.getItem('filtered_workflow_engagement') || '';

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      data.handleSearch();
    }
  };

  return (
    <div>
      <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
        <Col span={10}>
          <TextField
            id="input-with-icon-textfield"
            size="small"
            label="Search"
            name="search"
            variant="outlined"
            value={data.search}
            onChange={data.handleOnChange}
            onKeyPress={handleKeyPress}
            InputProps={{
              endAdornment: <FiSearch onClick={data.handleSearch} style={{ cursor: 'pointer' }} />,
            }}
            sx={{ background: '#ffffff', mt: 0.5 }}
            autoComplete="off"
          />
        </Col>

        <Col span={14}>
          <Row
            gutter={[8, 16]}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
          >
            {data.isFirstFilterVisible && (
              <Col span={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ backgroundColor: '#ffffff', mr: '8px' }}
                >
                  <InputLabel
                    id="first-filter-label"
                    sx={{
                      maxWidth: 'calc(100% - 30px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -7px) scale(0.75)',
                      },
                    }}
                  >
                    {data.firstFilterText}
                  </InputLabel>

                  <Select
                    labelId="first-filter-label"
                    id="first-filter"
                    value={data.region}
                    onChange={data.handleRegion}
                    label={data.firstFilterText}
                    sx={{
                      '& .MuiSelect-select': { paddingRight: '30px' },
                      '& .MuiSelect-icon': { right: 8 },
                    }}
                  >
                    {data?.firstFilterValues?.filterData?.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Col>
            )}

            {data.isSecondFilterVisible && (
              <Col span={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ backgroundColor: '#ffffff', mr: '8px' }}
                >
                  <InputLabel
                    id="second-filter-label"
                    sx={{
                      maxWidth: 'calc(100% - 30px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -7px) scale(0.75)',
                      },
                    }}
                  >
                    {data.secondFilterText}
                  </InputLabel>

                  <Select
                    labelId="second-filter-label"
                    id="second-filter"
                    value={data.status}
                    onChange={data.handleStatus}
                    label={data.secondFilterText}
                    sx={{
                      '& .MuiSelect-select': { paddingRight: '30px' },
                      '& .MuiSelect-icon': { right: 8 },
                    }}
                  >
                    {data.filterClientLoading ? (
                      <MenuItem disabled>
                        <CircularProgress size={20} /> &nbsp; Loading...
                      </MenuItem>
                    ) : (
                      data?.secondFilterValues?.filterData?.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Col>
            )}

            {data.isThirdFilterVisible && (
              <Col span={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ backgroundColor: '#ffffff', mr: '8px' }}
                >
                  <InputLabel
                    id="third-filter-label"
                    sx={{
                      maxWidth: 'calc(100% - 30px)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -7px) scale(0.75)',
                      },
                    }}
                  >
                    {data.thirdFilterText}
                  </InputLabel>

                  <Select
                    labelId="third-filter-label"
                    id="third-filter"
                    value={data.engagement}
                    onChange={data.handleEngagement}
                    label={data.thirdFilterText}
                    sx={{
                      '& .MuiSelect-select': { paddingRight: '30px' },
                      '& .MuiSelect-icon': { right: 8 },
                    }}
                  >
                    {data.filterLoading ? (
                      <MenuItem disabled>
                        <CircularProgress size={20} /> &nbsp; Loading...
                      </MenuItem>
                    ) : (
                      data?.thirdFilterValues?.filterData?.map((item) => (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Col>
            )}

            <Col span={4}>
              <Button
                size="small"
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: '#00043C',
                  '&:hover': { backgroundColor: '#00043C' },
                  height: '40px',
                  fontSize: '12px',
                }}
                onClick={data.handleClearFilter}
              >
                {data.clearFilterText}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}